import { Conversation } from "../messaging/types";
import { RootAction } from "../types";
import { SecureMessageStep } from "./types";

export interface State {
  data: {
    step: SecureMessageStep;
    conversation: Conversation | null;
    messageId: string;
    pinSet: boolean;
    participantType: string;
    dateOfBirth: string;
  };
  loading: boolean;
  errorMessage: string;
}

const blankState = () => ({
  data: {
    messageId: "",
    pinSet: false,
    participantType: "",
    conversation: null,
    step: SecureMessageStep.Init,
    dateOfBirth: ""
  },
  loading: false,
  errorMessage: ""
});

export default (state: State = blankState(), action: RootAction) => {
  switch (action.type) {
    case "secureMessage/setRouteState":
      return {
        ...state,
        loading: false,
        data: {
          ...state.data,
          messageId: action.messageId,
          pinSet: action.pinSet,
          participantType: action.participantType
        }
      };
    case "secureMessage/setSecureMessageStep":
      return {
        ...state,
        loading: false,
        errorMessage: null,
        data: {
          ...state.data,
          step: action.step
        }
      };
    case "secureMessage/forgotPin":
      return {
        ...state,
        loading: false,
        errorMessage: null,
        data: {
          ...state.data,
          step: action.step,
          pinSet: action.pinSet
        }
      };
    case "secureMessage/getConversation-started":
      return {
        ...state,
        loading: true
      };
    case "secureMessage/getConversation-success":
      return {
        ...state,
        loading: false,
        error: null,
        data: {
          ...state.data,
          conversation: action.conversation
        }
      };
    case "secureMessage/getConversation-failure":
      return {
        ...state,
        loading: false,
        errorMessage: action.errorMessage
      };
    case "secureMessage/verifyDateOfBirth-started":
      return {
        ...state,
        loading: true
      };
    case "secureMessage/verifyDateOfBirth-success":
      return {
        ...state,
        loading: false,
        error: null,
        data: {
          ...state.data,
          dateOfBirth: action.dateOfBirth
        }
      };
    case "secureMessage/verifyDateOfBirth-failure":
      return {
        ...state,
        loading: false,
        errorMessage: action.errorMessage
      };
    case "secureMessage/registerParticipant-started":
      return {
        ...state,
        loading: true
      };
    case "secureMessage/registerParticipant-success":
      return {
        ...state,
        loading: false,
        error: null,
        data: {
          ...state.data
        }
      };
    case "secureMessage/registerParticipant-failure":
      return {
        ...state,
        loading: false,
        errorMessage: action.errorMessage
      };
    case "secureMessage/authenticateParticipant-started":
      return {
        ...state,
        loading: true
      };
    case "secureMessage/authenticateParticipant-success":
      return {
        ...state,
        loading: false,
        error: null,
        data: {
          ...state.data
        }
      };
    case "secureMessage/authenticateParticipant-failure":
      return {
        ...state,
        loading: false,
        errorMessage: action.errorMessage
      };
  }

  return state;
};
